// Persoonlijke scenario's in IndexedDB (zie §6.1). De `scenarios` object-
// store wordt gedeeld met (eventuele toekomstige) caches; key = scenario.id.

import { getDb } from "./indexedDb";
import type { Scenario } from "../types/scenario";

const STORE = "scenarios";

export async function listPersonalScenarios(): Promise<Scenario[]> {
  try {
    const db = await getDb();
    const all = (await db.getAll(STORE)) as Scenario[];
    // Sorteer op updatedAt desc.
    return all.sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1));
  } catch (err) {
    console.warn("[personalScenarios] list failed:", err);
    return [];
  }
}

export async function getPersonalScenario(id: string): Promise<Scenario | undefined> {
  try {
    const db = await getDb();
    return (await db.get(STORE, id)) as Scenario | undefined;
  } catch (err) {
    console.warn("[personalScenarios] get failed:", err);
    return undefined;
  }
}

export async function savePersonalScenario(scenario: Scenario): Promise<void> {
  try {
    const db = await getDb();
    await db.put(STORE, scenario);
  } catch (err) {
    console.warn("[personalScenarios] save failed:", err);
  }
}

export async function deletePersonalScenario(id: string): Promise<void> {
  try {
    const db = await getDb();
    await db.delete(STORE, id);
  } catch (err) {
    console.warn("[personalScenarios] delete failed:", err);
  }
}
